import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "form-floating mb-4" }
const _hoisted_3 = { class: "my-3 text-danger" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_month_and_year = _resolveComponent("month-and-year")!
  const _component_inflation = _resolveComponent("inflation")!
  const _component_bad_response_viewer = _resolveComponent("bad-response-viewer")!
  const _component_lock_button = _resolveComponent("lock-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_currency_input, {
        ref: "uiStartingIncome",
        description: "annual starting income",
        elementId: "startingIncome",
        onEntered: _ctx.onSaveShortcut
      }, null, 8, ["onEntered"])
    ]),
    _withDirectives(_createElementVNode("p", _hoisted_3, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1),
      _createTextVNode(" Current value not valid. ")
    ]), 512), [
      [_vShow, _ctx.showValidation]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_month_and_year, {
        ref: "payableFrom",
        monthLabel: "payable from month",
        yearLabel: "year",
        ariaMonthLabel: "Payable from month",
        ariaYearLabel: "Payable from year",
        defaultYearRange: 40
      }, null, 512)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_inflation, { ref: "inflation" }, null, 512)
    ]),
    _createVNode(_component_bad_response_viewer, { ref: "badResponseViewer" }, null, 512),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_lock_button, {
        text: _ctx.buttonText,
        "async-action": _ctx.onSaveClicked
      }, null, 8, ["text", "async-action"]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary me-md-2",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancelClicked && _ctx.onCancelClicked(...args)))
      }, " Cancel ")
    ])
  ], 64))
}